	var INFINITE_TOP_LINE       = 300;
	var INFINITE_BOTTOM_LINE    = 300;	
	var INFINITE_ANIMATION_LINE = 100;
	var SCROLL_MODE             = 1;
	var BUTTON_MODE             = 2;

(function ($) {	
    $.fn.infiniteScroll = function (options)    {
        $this = $(this);
        
        var lastMode = null;
        
        // Gestisco la chiamata ai metodi pubblici
    	if ($(this).data("infiniteScroll")) {
        	if ( $(this).data("infiniteScroll").methods[options] ) {
        		return $(this).data("infiniteScroll").methods[options].apply( this, Array.prototype.slice.call( arguments, 1 ));
        	}	
    	}
    	else {            
    		// Gestisco il merge con le opzione passate da parametro all'infiniteScroll
            var defaultOpts = $.extend({}, {
            	"methods" : {
            		"unlock" : unlock,
            		"locktop" : lockTop,
            		"lockBottom": lockBottom,
            		"callTop" : callTop,
            		"callBottom" : callBottom,
            		"removeBottomButton" : removeBottomButton,
            		"removeTopButton" : removeTopButton,
            		"insertHTML" : insertHTML
            	},
        		"callScrollTop" : removeTopButton,
                "callScrollBottom" : removeBottomButton,
        		// Definisce nel caso sia necessario quale infinity chaimare
        		"defaultOnBottom" : true,
        		"$scrollContainer" : null,
        		"$htmlContainer" : $this,
                "topSeqNum" : null,
                "bottomSeqNum" : null,
                "instanceReference" : null,
                "isInfiniteScrollVisible" : null,
                
        		//========================
        		//   PRIVATE
        		//========================
                "topLock" : false,
                "bottomLock" : false,
                "resizeElement" :  {h: 0},
                
            }, options);

            if (!isDefined(defaultOpts.$htmlContainer)) {
        		defaultOpts.$htmlContainer = $this;
        	}
            
        	// Se non � stato specificato lo scrollContainer lo inizializzo con l'elemento pi� vicino contenente una scrollbar
        	// TODO - Controllare il caso in cui non ci sia alcun elemento con la scrollbar
        	if (!isDefined(defaultOpts.$scrollContainer)) {
        		defaultOpts.$scrollContainer = $(findScrollbar(defaultOpts.$htmlContainer.get(0)));
        	}
        	
        	var toCall = function() {
        		var height = defaultOpts.$htmlContainer.height();
        		var data   = defaultOpts.resizeElement;

        		if (height !== data.h ) {
        			defaultOpts.resizeElement =  {h: height};
        			init();
        		}
        	};
        	       
        	if (mutationObserverSupported()) {
	        	var observer = new MutationObserver(toCall);
		    	
				// configuration of the observer:
				var config = { childList : false,
				  attributes : true,
				  characterData : true,
				  subtree : true,
				  attributeOldValue : false,
				  characterDataOldValue : false };
				 
				// pass in the target node, as well as the observer options
				observer.observe(defaultOpts.$htmlContainer.parent()[0], config);

        	}
        	else {
        		defaultOpts.$htmlContainer.resizeElement(toCall);
        	}

        	$this.data("infiniteScroll", defaultOpts);
        	
			// In base all'orientamento metto il lock inizialein una delle direzioni, (se necessario saranno sloccate dalle notifiche)
			if (defaultOpts.defaultOnBottom) {
				lockTop();
			}
			else {
				lockBottom();
			}
            
            init();
            
            if (defaultOpts.$scrollContainer.hasScroll('y') && !isInfiniteScrollVisible()) {
            	defaultOpts.$htmlContainer.find(".buttonResultLI button").trigger("click");
            	removeButtons();
            }
    	}

        /**
         * Inizializzazione l'impostazione di funzionamento del plugin. Se indico una direzione, viene
         */
        function init(direction) {     
			if (isInfiniteScrollVisible()) {
				if (lastMode != SCROLL_MODE) {
					lastMode=SCROLL_MODE;
					defaultOpts.$scrollContainer.off('scroll.infinity');
					
					var buttons = defaultOpts.$htmlContainer.find(".buttonResultLI button").trigger("click");
				
					defaultOpts.$scrollContainer.on("scroll.infinity", function() {
						callInfinite();
					});
					
					removeButtons();
				}
				

				
				callInfinite();
			}
			else {
				if (lastMode != BUTTON_MODE){
					lastMode=BUTTON_MODE;
					defaultOpts.$scrollContainer.off('scroll.infinity');
					
					removeButtons();
				}
								
				// Attivo i pulsanti
				activateButton(false);
			}
        };
		
		/**
         * Esegue dei controlli per decidere se richiedere ulterioer HTML da inserire in top/bottom
         * 
         */
        function callInfinite() {
			var scrollHeight    = defaultOpts.$scrollContainer.get(0).scrollHeight;
			var containerHeight = defaultOpts.$htmlContainer.get(0).scrollHeight
			var toTop           = defaultOpts.$scrollContainer.scrollTop();
			var toBottom        = scrollHeight - (toTop + defaultOpts.$scrollContainer.height());
			
			// L'html da inserire sopra/sotto
			if (defaultOpts.defaultOnBottom) {
				if (!defaultOpts.bottomLock && toBottom < INFINITE_BOTTOM_LINE) {
					lockBottom();
					loadingButton(insertLoadingButton(false).find(".bottomButton"));
					callBottom(true);
				}
				else if (!defaultOpts.topLock && toTop < INFINITE_TOP_LINE) {
					lockTop();
					loadingButton(insertLoadingButton(true).find(".topButton"));
					callTop(false);
				}
			}
			else {
				if (!defaultOpts.topLock && toTop < INFINITE_TOP_LINE) {
					lockTop();
					loadingButton(insertLoadingButton(true).find(".topButton"));
					callTop(false);
				}
				else if (!defaultOpts.bottomLock && toBottom < INFINITE_BOTTOM_LINE) {
					lockBottom();
					loadingButton(insertLoadingButton(false).find(".bottomButton"));
					callBottom(true);
				}
			}
        };
        
        /**
         * Blocca la richiesta di ulteriori inserimenti, specificando sul top
         */
        function lockTop() {
       		defaultOpts.topLock = true;
        };
        
        /**
         * Blocca la richiesta di ulteriori inserimenti, specificando sul top
         */
        function lockBottom() {
        	defaultOpts.bottomLock = true;
        };
		
        /**
         * Sblocca la richiesta di nuovi inserimenti sia sul Top che sul Bottom
         * 
         * onHead indica se si deve slocckare solo l'infinity in testo (true) o in coda (false)  
         */
	    function unlock(onTop) {
	    	// Gestisco i lock in base al caso
			if (onTop) {
				defaultOpts.topLock = false;		
			}
			else {
				defaultOpts.bottomLock = false;		
			}
	    	
			removeLoadingButtons();
		};
		
		function callTop(animation) {
			defaultOpts.callScrollTop(defaultOpts, animation);
		}
		
		function callBottom(animation) {
			defaultOpts.callScrollBottom(defaultOpts, animation);
		}
		
		function activateButton(toScroll) {		
			if (!isDefined(defaultOpts.$htmlContainer)) {
				return;
			}
						
			var $scroll = defaultOpts.$scrollContainer;

			var scrollHeight = 0;
			var scrollBottom = 0;
			var scrollTop    = 0;
			if (isDefined($scroll) && $scroll.size()) {
				// Serviranno per mantenere la posizione della visuale
				scrollHeight = $scroll.get(0).scrollHeight;
				scrollBottom = $scroll.get(0).scrollHeight - $scroll.scrollTop();
				scrollTop    = $scroll.scrollTop();
			}
			
			if (!defaultOpts.topLock && !defaultOpts.$htmlContainer.find(".topButton").size()) {
				
				var $button = insertButton(true);
				
				$button.find(".topButton").click(function() {
					loadingButton($(this));
					lockTop();
					callTop(false);
				});
				
				if (isInfiniteScrollVisible()) {
					$button.find(".topButton").trigger( "click" );
				}
			}
			
			if (!defaultOpts.bottomLock && !defaultOpts.$htmlContainer.find(".bottomButton").size()) {
				
				var $button = insertButton(false);
				
				$button.find(".bottomButton").click(function() {
					loadingButton($(this));
					lockBottom();
					callBottom(false);
				});
				
				if (isInfiniteScrollVisible()) {
					$button.find(".bottomButton").trigger( "click" );
				}
			} 
			
			if (toScroll && isDefined($scroll) && $scroll.size()) {
				// Serviranno per mantenere la posizione della visuale
				var newScrollHeight = $scroll.get(0).scrollHeight;
				var newScrollBottom = $scroll.get(0).scrollHeight - $scroll.scrollTop();
				var newSscrollTop   = $scroll.scrollTop();
								
				var animatePx = newScrollHeight - scrollHeight + scrollTop;
				if (!defaultOpts.defaultOnBottom || scrollTop>0) {
					$scroll.scrollTop(animatePx);
				}
			}
			

		}
		
		function insertButton(onTop) {
			var otherResult = getLabel("otherResults");
			
			var $button = null;
			
			if (onTop) {
				$button = $('<li class="de_inbox_detail_item buttonResultLI"><button class="topButton"><span class="loadingText">'+otherResult+'</span></button></li>');
				defaultOpts.$htmlContainer.prepend($button);
			}
			else {
				$button = $('<li class="de_inbox_detail_item buttonResultLI"><button class="bottomButton"><span class="loadingText">'+otherResult+'</span></button></li>');
				defaultOpts.$htmlContainer.append($button);
			}
			
			return $button;
		}
		
		function insertLoadingButton(onTop) {
			var loading = getLabel("Loading");
			
			var $button = null;
			
			if (onTop) {
				$button = $('<li class="de_inbox_detail_item buttonResultLI"><button class="topButton"><span class="loadingText">'+loading+'</span></button></li>');
				defaultOpts.$htmlContainer.prepend($button);
			}
			else {
				$button = $('<li class="de_inbox_detail_item buttonResultLI"><button class="bottomButton"><span class="loadingText">'+loading+'</span></button></li>');
				defaultOpts.$htmlContainer.append($button);
			}
			
			return $button;
		}
		
		function insertHTML(json, onTop, animation) {
			addDataToCtx(json.ctx, "instanceReference", defaultOpts.instanceReference);
			
			if (isDefined(json) && isDefined(defaultOpts.$htmlContainer) && defaultOpts.$htmlContainer.size()) {				
				var $html = $(rootPage.templateRenderizer(json, {"ctx" : json.ctx}));
				$html.hide();
				
				// Mi calcolo i valori della scroll, perch� potrebbero servire in seguito
				var $scroll      = defaultOpts.$scrollContainer;
				
				var scrollHeight = $scroll.get(0).scrollHeight;
				var scrollBottom = $scroll.get(0).scrollHeight - defaultOpts.$scrollContainer.scrollTop();
				var scrollTop    = $scroll.scrollTop();
				
				if (onTop) {
					var firstChild = defaultOpts.$htmlContainer.children(":first");
					
					if (firstChild.size()) {
						$html.insertBefore(firstChild);
						
					}
					else {
						defaultOpts.$htmlContainer.append($html);
					}
					
				}
				else {
					defaultOpts.$htmlContainer.append($html);
				}
				
				applyAnimation($html, animation);
				
				if (onTop && isInfiniteScrollVisible()) {
					var newScrollHeight = $scroll.get(0).scrollHeight;
					var newScrollBottom = $scroll.get(0).scrollHeight - defaultOpts.$scrollContainer.scrollTop();
					var newSscrollTop   = $scroll.scrollTop();					
				
					var animatePx = newScrollHeight - scrollHeight + scrollTop;
					if (!defaultOpts.defaultOnBottom || scrollTop>0) {
						$scroll.scrollTop(animatePx);
					}
				}
				
				refreshPrettyDateIntoPage($html);
			}
		};

		function removeBottomButton() {
			defaultOpts.$htmlContainer.find(".bottomButton").closest(".buttonResultLI").remove();
		}
		
		function removeTopButton() {
			defaultOpts.$htmlContainer.find(".topButton").closest(".buttonResultLI").remove();
		}
		
		function removeButtons() {
			defaultOpts.$htmlContainer.find(".buttonResultLI").remove();
		}
		
		function removeLoadingButtons() {
			var buttons = defaultOpts.$htmlContainer.find(".button_loading");
			for (var i=0; i<buttons.length; i++) {
				var $button = $(buttons[i]);
				$button.closest(".buttonResultLI").remove();
			}
		}
		
		/**
		 * TRUE  - Se sullo scrollContainer � visibile la scrollBarVerticale
		 * FALSE - Se sullo scrollContainer non � visibile la scrollBarVerticale
		 */
		function isInfiniteScrollVisible() {
			var GAP = 0;
			
			if (isDefined(defaultOpts.isInfiniteScrollVisible)) {
				return defaultOpts.isInfiniteScrollVisible(defaultOpts);
			}
			
        	var scrollHeight    = defaultOpts.$scrollContainer.get(0).scrollHeight;
        	var containerHeight = defaultOpts.$htmlContainer.get(0).scrollHeight;
        	var height = defaultOpts.$scrollContainer.height();

			return scrollHeight > (height + GAP);
		}		
    };
})(jQuery);

//# sourceMappingURL=jquery.infiniteScroll.js.map
;
